var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[(_vm.isLoading)?_c('back-loading'):_c('div',[(_vm.isErrorSet)?_c('error-data'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }